import React, { Component } from 'react';
import { connect } from 'react-redux';
import LazyImage from './../LazyImage';
import FormationPlaceholder from './FormationPlaceholder'
import OutsideNotifier from '../../OutsideNotifier';
import { findDOMNode } from 'react-dom';
import { TweenMax } from "gsap/TweenMax";
import {
    updatePopupVisibility,
    createTeamForSelectedFormation
} from './../../actions/FormationActions';
import config from './../../config';
import common from './../../common';

class FormationPopup extends Component {
    render() {
        if (this.props.isVisible) {
            return (
                <div className="si-modal-wrap">
                    <FormationInner { ...this.props } />
                </div>)
        } else {
            return null;
        }
    }
}

class FormationInner extends Component {
    componentDidMount() {
        const el = findDOMNode(this);
        TweenMax.fromTo(el, 0.4, {
            opacity: 0
        }, {
                opacity: 1
            })
    }

    showHidePopup = () => {
        this.props.updatePopupVisibility();
    };
    onFormationClick = (newFormationId, formationString) => {
        let pageName = "";
        if (window.location.pathname.indexOf("/manage-team")) {
            pageName = "/uclfantasy/my-team/manage/"
        } else {
            pageName = "/uclfantasy/create-team/"
        }
        common.customTracking('Change Formation - ' + formationString, pageName);
        const oldFormationId = this.props.defaultFormationIndex;
        if (newFormationId !== oldFormationId) {
            if (this.props.sendToSubs) {
                this.props.handleNext("substitute");
            }

            this.props.setDefaultFormation(this.props.constraints, oldFormationId, newFormationId);
        }
    };
    handleClickOutside = evt => {
        evt.stopPropagation();
        this.props.updatePopupVisibility();
    };

    render() {
        let formationsData = this.props.formations;
        const defaultFormationCompID = this.props.defaultFormationIndex;
        formationsData = formationsData.filter(formation => +formation.CompId !== 9);
        const formationList = formationsData.map((formation) => {
            let fwd = formation.FWD;
            let mid = formation.MID;
            let def = formation.DEF;
            let formationStr = def + '-' + mid + '-' + fwd;
            let imgSrc = config.playerImgBase + 'formations/' + formationStr + '.png';
            let isDefaultClass = defaultFormationCompID === formation.CompId;
            const defaultClass = common.makeClasses({
                'si-formation-box': true,
                'si-active': isDefaultClass,
                'si-inactive': !isDefaultClass,
                'si-disabled': !formation.IsActive,
            });
            let topSelected = formation['IsTopSelected'] ?
                <div className="si-tooltip">{ this.props.trans.most_picked }</div> : '';
            const clickHandler = formation.IsActive ? { onClick: () => this.onFormationClick(formation.CompId, formationStr) } : {};
            return <div className={ "si-formation-wrap" } key={ formation.CompId }>
                { topSelected }
                <div className={ defaultClass }
                    { ...clickHandler }>
                    <span>{ formationStr }</span>
                    <LazyImage src={ imgSrc } alt="" placeholder={ <FormationPlaceholder /> } />
                </div>
            </div>
        });
        return <OutsideNotifier handler={ (e) => this.handleClickOutside(e) }>
            <div className="si-formations-popup si-common-popup">
                <div className="si-formation-header si-flexBox">
                    <span>{ this.props.trans.formations }</span>
                    <i className="si-close icon-ucl-close" onClick={ () => this.showHidePopup() } />
                </div>
                <div className="si-formation-body si-flexBox">
                    { formationList }
                </div>
            </div>
        </OutsideNotifier>
    }
}

const mapStateToProps = (state) => {
    return {
        trans: state.appData.trans,
        constraints: state.appData.constraints,
        formations: state.formationData.formations,
        defaultFormationIndex: state.formationData.defaultFormationIndex,
        isVisible: state.formationData.isVisible,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        updatePopupVisibility: () => dispatch(updatePopupVisibility()),
        setDefaultFormation: (constraints, oldFormationId, newFormationId) => dispatch(createTeamForSelectedFormation(constraints, oldFormationId, newFormationId)),
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(FormationPopup);


// WEBPACK FOOTER //
// ./src/components/onboarding/FormationPopup.js